import GridView from "../../components/controls/GridView/GridView";
import { useState } from "react";
import tellerService, { Teller } from "../../services/tellerService";
import Frame from "../../components/controls/Frame/Frame";
import FormModal from "../../components/controls/FormModal";
import FindAccount from "../../components/controls/FindAccount/FindAccount";
import FindRecord from "../../components/controls/FindRecord";
import FormCommand from "../../components/controls/FormCommand";
import TextBox from "../../components/controls/TextBox/TextBox";
import userService, { User } from "../../services/userService";

export interface TellerListingPageProps {}

export const TellerListingPage = (props: TellerListingPageProps) => {
  const [teller, setTeller] = useState<Teller>();
  const [tellers, setTellers] = useState<Teller[]>();

  return (
    <>
      <div className="row">
        <div className="col">
          <Frame>
            <h4>Tellers / Cashiers</h4>
            <GridView
              showSearchBar={true}
              context="Tellers"
              onAddRecord={() => {
                setTeller({});
              }}
              showAddButton={true}
            >
              <GridView.Header>
                <thead>
                  <tr>
                    <td>Teller ID</td>
                    <td>Teller Name</td>
                    <td>Vault</td>
                    <td>Action</td>
                  </tr>
                </thead>
              </GridView.Header>
              <GridView.Content>
                {tellers?.map((d) => (
                  <tr>
                    <td>{d.name}</td>
                    <td></td>
                    <td></td>
                  </tr>
                ))}
              </GridView.Content>
            </GridView>
          </Frame>
        </div>
      </div>

      {teller && (
        <FormModal onClose={() => setTeller(undefined)}>
          <TellerRegistrationForm />
        </FormModal>
      )}
    </>
  );
};

export type TellerRegistrationFormProps = {};

export function TellerRegistrationForm(props: TellerRegistrationFormProps) {
  const [teller, setTeller] = useState<
    | {
        name?: string;
        userId?: number;
        tillAccountId?: number;
        vaultAccountId?: number;
        transactionLimit?: number;
      }
    | undefined
  >();

  return (
    <div className="row">
      <div className="col">
        <TextBox
          id="tellerName"
          text="Enter teller Name"
          onChange={(e) =>
            setTeller({ ...teller, name: e.currentTarget.value })
          }
          value={teller?.name}
        />

        <FindRecord<User | undefined>
          text="Select User"
          id="userId"
          onSelectRecord={(user) => {
            console.log("OnUserSelected : " + user);
            return user;
          }}
          getRecords={() => {
            return userService.getUsers({});
          }}
        />

        <div className="row">
          <div className="col">
            <FindAccount
              text="Till Account"
              id="tillAccountId"
              onAccountSelected={(account) =>
                setTeller({ ...teller, tillAccountId: account.id })
              }
            />
          </div>
          <div className="col">
            <FindAccount
              text="Vault Account"
              id="vaultAccountId"
              onAccountSelected={(account) =>
                setTeller({ ...teller, vaultAccountId: account.id })
              }
            />
          </div>
        </div>

        <div className="row">
          <div className="col">
            <div className="form-group">
              <label htmlFor="transactionLimit" className="control-label">
                Transaction Limit
              </label>
              <input
                type="number"
                name="transactionLimit"
                id="transactionLimit"
                className="form-control"
                value={teller?.transactionLimit}
                onBlur={(e) =>
                  setTeller({
                    ...teller,
                    transactionLimit: e.currentTarget.valueAsNumber,
                  })
                }
              />
            </div>
          </div>
        </div>

        <FormCommand
          onSubmit={() => {
            const registerTeller = async () => {
              const res = await tellerService.addOrUpdateTeller({
                name: teller?.name ?? "",
                userId: teller?.userId,
                vaultAccountId: teller?.vaultAccountId,
                transactionLimit: teller?.transactionLimit,
              });

              if (res.status) {
                window.alert(res.message);
                setTeller(undefined);
              }
            };
            registerTeller();
          }}
        />
      </div>
    </div>
  );
}
